var musicI18n = require('@cdo/music/locale');
export default musicI18n;
